import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EditOutlined } from '@ant-design/icons';
import { socketEmitEvent } from '../../redux/actions';
import * as SERVICE from '../../constants/service.types';
import colorsDark from '../../assets/colors/dark';
import { message, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import LocationSearchLocationIQ from '../../components/LocationSearchLocationIQ';
import { onlyLettersAndNumbers } from '../../helpers/groupByCoors';

const { TabPane } = Tabs;

const InfoWindowGatewayComponent = ({ devices, setKeyMap, setMode }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { namespace, updateDevice } = useSelector((state) => state);
  const [listGateway, setListGateway] = useState(devices);
  const [isEditNote, setIsEditNote] = useState(false);
  const [address, setAddress] = useState({
    note: '',
    lat: 0,
    lng: 0,
  });
  const [isBlock, setIsBlock] = useState(false);
  const [requestId, setRequestId] = useState(new Date().getTime());

  useEffect(() => {
    if (devices) {
      setListGateway(devices);
    }
  }, [devices]);

  useEffect(() => {
    if (updateDevice && updateDevice.requestId === requestId) {
      setMode(0)
      setKeyMap(Math.random())
    }
  }, [updateDevice]);

  const handleAddressChange = (address) => {
    setAddress((state) => ({
      ...state,
      note: address,
    }));
  };

  const handleSelect = (address) => {
    setAddress(address);
  };

  const handleResetLocation = () => {
    setIsEditNote(false)
    setAddress({
      note: '',
      lat: 0,
      lng: 0,
    })
  }

  const handleOnUpdateNote = (value) => {
    if (onlyLettersAndNumbers(address.note)) {
      const dataUpdate = {
        name: value.name,
        note: address.note,
        serial: value.serial,
        lat: address.lat,
        lng: address.lng,
      };
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest)
      let dataObj = {
        appServiceType: SERVICE.UPDATE_DEVICE,
        requestId: dataTimeRequest,
        body: JSON.stringify({ ...dataUpdate, namespace }),
      };
      handleResetLocation();
      return dispatch(socketEmitEvent(dataObj));
    } else {
      message.warning(t('Please enter only letters and numbers!'));
    }
  }

  return (
    <div className="info-window-device">
      <Tabs
        tabPosition="bottom"
        size="small"
        style={{ maxWidth: 300 }}
        onChange={() => handleResetLocation()}
      >
        {listGateway &&
          listGateway.map((gateway, index) => (
            <TabPane tab={gateway.name} key={index}>
              <div
                style={{ color: colorsDark.$darkest }}
                className="main-view-gateway"
              >
                <div className="name-gateway">{gateway.name}</div>
                {gateway.performance && (
                  <div className="gateway-performance">
                    <div className="performance">
                      {t('State')}:{' '}
                      <span>
                        {t(gateway.state === 1 ? t('Online') : t('Offline'))}
                      </span>
                    </div>
                    <div className="performance">
                      Ram: <span>{gateway.performance.ram} %</span>
                    </div>
                    <div className="performance">
                      CPU: <span>{gateway.performance.disk} %</span>
                    </div>
                    <div className="performance">
                      {t('Storage usage')} :{' '}
                      <span>
                        {gateway.performance.disk}/
                        {gateway.performance.totalDisk} GB
                      </span>
                    </div>
                  </div>
                )}
                <div className="note-gateway">
                  {isEditNote ? (
                    <div>
                      {t('Address')}:{' '}
                      <LocationSearchLocationIQ
                        address={address.note}
                        onChange={handleAddressChange}
                        onAddressSelect={handleSelect}
                        setIsBlock={setIsBlock}
                      />
                    </div>
                  ) : (
                    <div>
                      {t('Address')}:{' '}
                      <span>{gateway.note ? gateway.note : t('Note empty')}</span>
                    </div>
                  )}
                  {isEditNote ? (
                    <div style={{ padding: '26px 0px 0px 8px' }}>
                      <span
                        style={{ marginRight: '10px', cursor: 'pointer', color: '#0E9347' }}
                        onClick={() => handleOnUpdateNote(gateway)}
                      >{t('Update')}</span>
                      <span
                        style={{ cursor: 'pointer', color: '#4F4D4D' }}
                        onClick={() => handleResetLocation()}
                      >{t('Cancel')}</span>
                    </div>
                  ) : (<EditOutlined
                    style={{ marginLeft: '8px', cursor: 'pointer' }}
                    onClick={() => {
                      setIsEditNote(true)
                      setAddress((state) => ({
                        ...state,
                        note: gateway.note ? gateway.note : '',
                      }));
                    }}
                  />)}
                </div>
              </div>
            </TabPane>
          ))}
      </Tabs>
    </div>
  );
};

export default InfoWindowGatewayComponent;
